import { StyleSheet } from 'react-native'

import { MotiView } from '@zet/common/components/motiView'
import { colors } from '@zet/design-system'
import { Skeleton } from 'moti/skeleton'

import { Spacer } from './spacer'

const BrandDetailsLoader = () => {
  return (
    <MotiView
      transition={{
        type: 'timing',
      }}
      style={[styles.container, styles.padded]}
      animate={{ backgroundColor: colors.neutral.white100 }}
    >
      <Skeleton colorMode={'light'} width={'100%'} height={150} />
      <Spacer height={8} />
      <Skeleton colorMode={'light'} width={'100%'} height={16} />
      <Spacer height={8} />
      <Skeleton colorMode={'light'} width={'100%'} />
      <Spacer height={8} />
      <Skeleton colorMode={'light'} width={'100%'} height={44} />
      <Spacer height={8} />
      <Skeleton colorMode={'light'} width={'100%'} height={30} />
      <Spacer height={8} />
      <Skeleton colorMode={'light'} width={'100%'} height={12} />
      <Spacer height={8} />
      <Skeleton colorMode={'light'} width={'100%'} height={20} />
      <Spacer height={8} />
      <Skeleton colorMode={'light'} width={'100%'} height={44} />
      <Spacer height={8} />
      <Skeleton colorMode={'light'} width={'100%'} height={16} />
      <Spacer height={8} />
      <Skeleton colorMode={'light'} width={'100%'} height={50} />
      <Spacer height={8} />
      <Skeleton colorMode={'light'} width={'100%'} height={24} />
    </MotiView>
  )
}

export default BrandDetailsLoader

const styles = StyleSheet.create({
  shape: {
    height: 250,
    width: 250,
    borderRadius: 25,
    marginRight: 10,
    backgroundColor: 'white',
  },
  container: {
    flex: 1,
  },
  padded: {
    padding: 16,
  },
})
